import React, { useEffect, useState } from 'react';
import { MessageService, ValidatorType } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isContentfulString, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as CheckmarkIcon } from '../../../resources/assets/components/DLS_CheckmarkStandAlone.svg';
import { ReactComponent as CrossIcon } from '../../../resources/assets/components/DLS_Cross.svg';
import { ReactComponent as ExclamationMarkIcon } from '../../../resources/assets/components/DLS_ExclamationMark_Circle.svg';
import './validation-list.css';
function getIcon(valid, type = ValidatorType.DEFAULT) {
    if (!valid) {
        return CrossIcon;
    }
    if (type === ValidatorType.WARNING) {
        return ExclamationMarkIcon;
    }
    return CheckmarkIcon;
}
function shouldRenderValidation(validation, hasFocus = false, options = {}) {
    if (!isContentfulString(validation.name)) {
        return false;
    }
    if (!validation.valid) {
        return true;
    }
    if (hasFocus && options.showWhenValid) {
        return true;
    }
    if (validation.type === ValidatorType.WARNING) {
        return true;
    }
    return false;
}
function ValidationItem(props) {
    const { hasFocus, validation, validator } = props;
    const { message, type = ValidatorType.DEFAULT, valid } = validation;
    if (!shouldRenderValidation(validation, hasFocus, validator?.options)) {
        return null;
    }
    const liClassName = classNames({
        'c-validation-list__item': true,
        'is-invalid': !valid,
        'is-valid': valid,
        [`is-${type}`]: isEnumValid(ValidatorType, type),
    });
    const Icon = getIcon(valid, type);
    const iconClassName = classNames({
        'c-validation-list__icon': true,
        't-color-signal-green': valid,
        't-color-signal-red': type === ValidatorType.DEFAULT,
        't-color-signal-yellow': valid && type === ValidatorType.WARNING,
    });
    return (React.createElement("li", { className: liClassName },
        React.createElement(Icon, { className: iconClassName }),
        MessageService.translate(message)));
}
function ValidationList(props) {
    const { className, data, validators } = props;
    const [validatorMap, setValidatorMap] = useState(new Map());
    useEffect(() => {
        if (!Array.isArray(validators)) {
            return;
        }
        const map = new Map();
        for (const validator of validators) {
            map.set(validator.name, validator);
        }
        setValidatorMap(map);
        return () => {
            setValidatorMap(new Map());
        };
    }, [validators]);
    if (!data.length) {
        return null;
    }
    const validationClassName = classNames({
        'c-validation-list': true,
        'u-hide@empty': true,
        [`${className}`]: Boolean(className),
    });
    return (React.createElement("ul", { className: validationClassName }, data.map((item) => {
        const validator = validatorMap.get(item.name);
        return (React.createElement(ValidationItem, { hasFocus: props.hasFocus, key: item.name, validation: item, validator: validator }));
    })));
}
export { ValidationList, };
export default ValidationList;
//# sourceMappingURL=validation-list.js.map